import { __assign } from "tslib";
import React from 'react';
export default function Left(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        React.createElement("polygon", { fill: "currentColor", points: "5.655 3.471 5.655 10.47 12.655 10.471 12.655 12.471 3.655 12.471 3.655 3.471", transform: "scale(1 -1) rotate(45 27.398 0)" })));
}
//# sourceMappingURL=Left.js.map